import Button from "components/Button/Button"
import { useWindowSize } from "helpers/hooks"
import ModalCustom from "."

export interface DeleteModalProps {
  content?: string
  label?: string
  title?: string | JSX.Element
  titleButton?: string
  onCloseModal: () => void
  onSubmit?: (event?: any) => void
  colorYellowButton?: boolean
  styleContent?: React.CSSProperties
  styleTitle?: React.CSSProperties
  contentWrapperStyles?: React.CSSProperties
  styleRoot?: React.CSSProperties
  isButtonCancel?: boolean
}

export interface CheckModalProps {
  content: React.ReactNode
  label: string
  contentWrapperStyles?: React.CSSProperties
}

const ModalDelete = (props: DeleteModalProps) => {
  const {
    content,
    label,
    title,
    titleButton,
    colorYellowButton,
    onCloseModal,
    onSubmit,
    styleContent,
    styleTitle,
    styleRoot,
    contentWrapperStyles = {
      paddingTop: 33,
      paddingBottom: 49,
    },
    isButtonCancel = true,
  } = props

  const { isMobile } = useWindowSize()

  return (
    <ModalCustom
      label={label ?? "Confirmation"}
      styleRoot={{
        width: isMobile ? "-webkit-fill-available" : 400,
        ...styleRoot,
      }}
      handleChangeButton={isButtonCancel ? () => onCloseModal : undefined}
      bodyChildren={
        <div className="flex flex-col">
          <div
            className="flex flex-col items-center"
            style={contentWrapperStyles}
          >
            <div
              style={{
                color: "#222222",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "24px",
                ...styleTitle,
              }}
            >
              {title ?? "Are you sure you wish to delete this component?"}
            </div>
            <p
              style={{
                color: "#222222",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "24px",
                ...styleContent,
              }}
            >
              {content ?? "This action cannot be undone."}
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between">
            {isButtonCancel ? (
              <Button
                widthBtn={"100%"}
                title="Cancel"
                colorBtn="white"
                onClick={onCloseModal}
              />
            ) : null}

            <Button
              widthBtn={"100%"}
              title={titleButton ? titleButton : ""}
              colorBtn={colorYellowButton ? "yellow" : "red"}
              onClick={onSubmit}
            />
          </div>
        </div>
      }
    />
  )
}
export default ModalDelete
